<template>
  <section id="policy">
    <div class="policy-container">
      <div class="text" v-html="content"></div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'policy',
  computed: {
    ...mapGetters(['fetchedPolicyTOS', 'fetchedPolicyPrivacy']),
  },
  data() {
    return {
      content: '',
    };
  },
  async created() {
    if (this.$route.params.type === 'privacy') {
      await this.$store.dispatch('FETCH_POLICY_PRIVACY');
      this.content = this.fetchedPolicyPrivacy;
    } else {
      await this.$store.dispatch('FETCH_POLICY_TOS');
      this.content = this.fetchedPolicyTOS;
    }
  },
};
</script>

<style scoped lang="scss">
.policy {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
}

.policy-container {
  width: 900px;
  margin: 0 auto;

  .text {
    font-size: 14px;
  }
}
</style>
